import { FC, useState } from 'react';
import React, { useContext } from 'react';
import { ClientLocal, PermissionType, UserDto, UserGroupWithDetailsDto } from 'models/index';
import globalContext, { userHasPermission } from './isWriteableBy';

interface IClientContext {
    client: ClientLocal;
    setClient: (item: ClientLocal) => void;

    currentUser: UserDto;
    setCurrentUser: (item: UserDto) => void;

    userGroups: UserGroupWithDetailsDto[];
    setUserGroups: (item: UserGroupWithDetailsDto[]) => void;

    userHasPermission: (permission: PermissionType) => boolean;
    //userGroupIds: number[];
}

const ClientContext = React.createContext<IClientContext>(null);

function getUserGroups(user: UserDto, groups: UserGroupWithDetailsDto[]) {
    return groups.filter(x => x.users.findIndex(y => y.id == user?.id) > 0);
}
function getUserGroupIds(user: UserDto, groups: UserGroupWithDetailsDto[]) {
    return getUserGroups(user, groups).map(x => x.id);
}

function useClientInner() {
    const [client, setClient] = useState<ClientLocal>(null);
    const [currentUser, setCurrentUser] = useState<UserDto>(null);
    const [userGroups, setUserGroups] = useState<UserGroupWithDetailsDto[]>(null);
    //const [userGroupIds, setUserGroupIds] = useState<number[]>(null);

    function setCurrentUsersWithCache(item: UserDto) {
        setCurrentUser(item);

        const groups = userGroups ?? [];

        //setUserGroupIds();

        globalContext.setUser(item);
        globalContext.setUserGroupIds(getUserGroupIds(item, groups))
    }

    function setUserGroupsWithCache(item: UserGroupWithDetailsDto[]) {
        setUserGroups(item);
        globalContext.setUserGroupIds(getUserGroupIds(currentUser ?? null, item))
    }

    function setClientWithCache(item: ClientLocal) {
        setClient(item);
        globalContext.setCompanyLocal(item);
    }

    function userHasPermissionLocal(requestedPermission: PermissionType) {
        return userHasPermission(requestedPermission, currentUser, client);
    }

    return {
        client, 
        setClient: setClientWithCache, 
        currentUser,
        setCurrentUser: setCurrentUsersWithCache,
        userGroups,
        setUserGroups: setUserGroupsWithCache,
        userHasPermission: userHasPermissionLocal,
    };
}

interface ClientContextProviderProps {
    children: React.ReactNode;
}
export const ClientContextProvider: FC<ClientContextProviderProps> = (props: { children: React.ReactNode }) => {
    const value = useClientInner();

    return <ClientContext.Provider value={value}>{props.children}</ClientContext.Provider>;
}

function useClient() {
    return useContext(ClientContext);
}

export default useClient;
